module.exports = __webpack_public_path__ + "static/media/514JamesPBrawleyDrNW_2018-06-12_172.1f48f90b.jpg";